import React, { createContext, useContext, useState, useCallback } from 'react'

import { FilterCriteria } from 'src/apollo/onlineOrdering'

export type FilterCriteriaContextType = {
  filterCriteria: FilterCriteria | null
  setFilterCriteria: (criteria: FilterCriteria | null) => void
  inStockOnly: boolean
  setInStockOnly: (value: boolean) => void
  clearFilterCriteria: () => void
}

const FilterCriteriaContext = createContext<
  FilterCriteriaContextType | undefined
>(undefined)

export const useFilterCriteria = () => {
  const context = useContext(FilterCriteriaContext)
  if (!context) {
    throw new Error(
      'useFilterCriteria must be used within FilterCriteriaProvider'
    )
  }
  return context
}

export const FilterCriteriaProvider = ({
  children
}: React.PropsWithChildren) => {
  const [filterCriteria, setFilterCriteria] = useState<FilterCriteria | null>(
    null
  )
  const [inStockOnly, setInStockOnly] = useState<boolean>(false)

  const updateFilterCriteria = useCallback(
    (criteria: FilterCriteria | null) => {
      setFilterCriteria(criteria)
    },
    []
  )

  const clearFilterCriteria = useCallback(() => {
    setFilterCriteria(null)
    setInStockOnly(false)
  }, [])

  return (
    <FilterCriteriaContext.Provider
      value={{
        filterCriteria,
        setFilterCriteria: updateFilterCriteria,
        inStockOnly,
        setInStockOnly,
        clearFilterCriteria
      }}
    >
      {children}
    </FilterCriteriaContext.Provider>
  )
}
